var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "results table-responsive container"
  }, [_c('table', {
    staticClass: "table align-middle"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "table-light"
  }, _vm._l(_vm.activities.results, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(" " + _vm._s(_vm._f("moment")(item.date, "DD/MM/YYYY")) + " "), item.is_archived ? _c('span', {
      staticClass: "archivedTag"
    }, [_vm._v("Archived")]) : _vm._e()]), _c('td', {
      staticClass: "dblText"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {}, [item.type === 'event' && item.sportType === 'cycling' ? _c('img', {
      staticClass: "mx-2",
      staticStyle: {
        "width": "35px"
      },
      attrs: {
        "src": "/assets/images/activities/ActivityCal.png"
      }
    }) : item.type === 'ride' && item.sportType === 'cycling' ? _c('img', {
      staticClass: "mx-2",
      staticStyle: {
        "width": "35px"
      },
      attrs: {
        "src": "/assets/images/activities/ActivityCycle.png"
      }
    }) : item.type === 'workout' && item.sportType === 'cycling' ? _c('img', {
      staticClass: "mx-2",
      staticStyle: {
        "width": "35px"
      },
      attrs: {
        "src": "/assets/images/activities/ActivityBars.png"
      }
    }) : item.type === 'event' && item.sportType === 'running' ? _c('img', {
      staticClass: "mx-2",
      staticStyle: {
        "width": "35px"
      },
      attrs: {
        "src": "/assets/images/activities/ActivityType_run.png"
      }
    }) : item.type === 'ride' && item.sportType === 'running' ? _c('img', {
      staticClass: "mx-2",
      staticStyle: {
        "width": "35px"
      },
      attrs: {
        "src": "/assets/images/activities/ActivityType_run.png"
      }
    }) : item.type === 'workout' && item.sportType === 'running' ? _c('img', {
      staticClass: "mx-2",
      staticStyle: {
        "width": "35px"
      },
      attrs: {
        "src": "/assets/images/activities/ActivityType_run.png"
      }
    }) : _vm._e()]), _c('div', {}, [_c('strong', [_vm._v(_vm._s(item.title))]), _c('br'), _vm._v(" " + _vm._s(item.routeName) + " ")])])]), _c('td', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.distance.toFixed(2)) + " KM")]), _c('td', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.elevation) + " M")]), _c('td', [_vm._v(_vm._s(item.watt) + " w")]), _c('td', [_vm._v(_vm._s(item.wattPerKg) + " w/kg")]), _c('td', [_vm._v(_vm._s(item.heartrate) + " bpm")]), _c('td', [_vm._v(_vm._s(item.rideDuration))]), _c('td', [_c('button', {
      staticClass: "btnAnalysis",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('view-activity', item.activityFileId, item.date);
        }
      }
    })]), _c('td', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.localGraphFileIds,
        expression: "localGraphFileIds"
      }],
      staticClass: "input_class_checkbox",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.activityFileId,
        "checked": Array.isArray(_vm.localGraphFileIds) ? _vm._i(_vm.localGraphFileIds, item.activityFileId) > -1 : _vm.localGraphFileIds
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.localGraphFileIds,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = item.activityFileId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.localGraphFileIds = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.localGraphFileIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.localGraphFileIds = $$c;
          }
        }
      }
    }), _c('button', {
      staticClass: "btnCompare input_compare",
      class: _vm.localGraphFileIds.indexOf(item.activityFileId) !== -1 ? 'active' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.onAddToGraph($event, item.activityFileId);
        }
      }
    })]), _c('td', [_c('button', {
      staticClass: "btnDownload",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('download-file', item.activityFileId);
        }
      }
    })])]);
  }), 0)])]), !_vm.finished ? _c('div', {
    staticClass: "contrLoadMore"
  }, [_vm.showArchiveButton ? _c('button', {
    staticClass: "ldmore",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('show-archived');
      }
    }
  }, [_vm._v(" LOAD FROM ARCHIVE ")]) : _c('button', {
    staticClass: "ldmore",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('load-more');
      }
    }
  }, [_vm._v(" LOAD MORE ")])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "table-dark"
  }, [_c('tr', [_c('th', [_vm._v("DATE")]), _c('th', [_vm._v("RIDE")]), _c('th', [_vm._v("DIST")]), _c('th', [_vm._v("ELEV")]), _c('th', [_vm._v("W "), _c('span', [_vm._v("(avg)")])]), _c('th', [_vm._v("W/KG "), _c('span', [_vm._v("(avg)")])]), _c('th', [_vm._v("HEART "), _c('span', [_vm._v("(avg)")])]), _c('th', [_vm._v("TIME")]), _c('th', {
    staticClass: "btn-w"
  }, [_vm._v("ANALYSIS")]), _c('th', {
    staticClass: "btn-w"
  }, [_vm._v("DOWNLOAD")])])]);
}]

export { render, staticRenderFns }